import { render, staticRenderFns } from "./SkillsEmptyState.vue?vue&type=template&id=d8923a1e&scoped=true&"
import script from "./SkillsEmptyState.vue?vue&type=script&lang=js&"
export * from "./SkillsEmptyState.vue?vue&type=script&lang=js&"
import style0 from "./SkillsEmptyState.vue?vue&type=style&index=0&id=d8923a1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8923a1e",
  null
  
)

export default component.exports